import {
  SortOrder,
  WeeklyWorkListFilterByPlanStatus,
  WeeklyWorkListSearchBy,
  WeeklyWorkListSortByTerm,
} from '@bechtel/types';
import { t } from '@lingui/macro';
import { PlanStatusType, WorkListDrawerValueProps } from '../worklist/types';

export const initialDrawerValues: WorkListDrawerValueProps = {
  searchBy: WeeklyWorkListSearchBy.TAG_ID,
  filterByCommodity: [],
  filterByMilestoneTypes: [],
  filterByPlanStatusTypes: [],
  sortBy: WeeklyWorkListSortByTerm.TAG,
  sortDir: SortOrder.DESC,
};

export const sortByList = [
  { id: 1, value: WeeklyWorkListSortByTerm.WP_NUMBER, label: t`Work Package` },
  { id: 2, value: WeeklyWorkListSortByTerm.MILESTONE_TYPE, label: t`Milestone Sequence` },
  { id: 3, value: WeeklyWorkListSortByTerm.TAG, label: t`Tag Id` },
];

export const searchByList = [
  {
    id: 1,
    searchByTerm: { type: WeeklyWorkListSearchBy.TAG_ID },
    label: t`Tag Id or Cost Code`,
  },
  {
    id: 2,
    searchByTerm: { type: WeeklyWorkListSearchBy.USER_ID },
    label: t`User Name`,
  },
  {
    id: 3,
    searchByTerm: { type: WeeklyWorkListSearchBy.WORKPACKAGE },
    label: t`Work Package`,
  },
];

export const planStatusList: PlanStatusType[] = [
  { id: 1, value: WeeklyWorkListFilterByPlanStatus.IN_PLAN, label: t`In Plan` },
  { id: 2, value: WeeklyWorkListFilterByPlanStatus.OUT_OF_PLAN, label: t`Out of Plan` },
];
